import { useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import { ModalProvider } from 'react-modal-hook'
import { Provider } from 'react-redux'
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom'
import { Slide, ToastContainer } from 'react-toastify'

import AuthCallback from 'modules/auth/views/callback'

import { AuthProvider } from 'providers/auth'
import { TermProvider } from 'providers/terms'
import { ThemeProvider, GlobalStyle } from 'providers/theme'

import store from 'store'

import App from './app'

import 'react-toastify/dist/ReactToastify.min.css'

// Componente para redirecionamento externo
const ExternalRedirect = ({ to }: { to: string }) => {
  useEffect(() => {
    window.location.replace(to)
  }, [to])

  return null
}

const container = document.getElementById('root')
const root = createRoot(container!)

root.render(
  <Provider store={store}>
    <Router>
      <AuthProvider>
        <ThemeProvider>
          <TermProvider>
            <ModalProvider>
              <GlobalStyle />
              <Routes>
                <Route path="/auth/callback" element={<AuthCallback />} />
                <Route
                  path="/mome"
                  element={<ExternalRedirect to="https://momeclub.toty.app" />}
                />
                <Route path="/:key?/*" element={<App />} />
              </Routes>
              <ToastContainer
                position="top-center"
                autoClose={6363}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                transition={Slide}
                theme="dark"
              />
            </ModalProvider>
          </TermProvider>
        </ThemeProvider>
      </AuthProvider>
    </Router>
  </Provider>,
)
